import CustomSelect from 'components/CustomSelect';

const FilterField = ({
  labels = (x) => x,
  options = [],
  filters = {},
  setFilters = () => {},
  label = '',
  name = '',
}) => {
  return (
    <CustomSelect
      label={label}
      options={options[name]?.map((v) => ({
        label: labels(v),
        value: v,
      }))}
      values={filters[name] ?? []}
      onChange={(event) => setFilters(fs => ({ ...fs, [name]: event.target.value }))}
    />
  );
};

export default FilterField;